<template>
  <v-card
    height="100%"
    :class="widgetOpts.editable ? 'rx-widget-edit' : 'rx-widget-view'"
    :outlined="widgetOpts.editable"
  >
    <v-toolbar v-if="!widget.hideToolbar" color="grey lighten-3" flat dense>
      {{ widget.widgetTitle }}
      <v-spacer></v-spacer>
    </v-toolbar>
    <component
      v-if="loadComponent"
      :is="loadComponent"
      :h="widget.h"
      :row-height="widgetOpts.rowHeight"
    />
    <slot name="default"></slot>
    <div v-if="widgetOpts.editable" class="wrap-edit-box" >
      <v-toolbar flat color="transparent">
          <v-spacer></v-spacer>
          <rx-btn class="pb-5 mr-n2" color="error" fab x-small @click="$emit('removeWidget', widget)">
            <v-icon>$btn_remove</v-icon>
          </rx-btn>
      </v-toolbar>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    widget: Object,
    widgetOpts: Object,
  },
  computed: {
    loadComponent() {
      let name = this.widget.widgetComponent;
      return () => import(`@/redworks/components/${name}`);
    },
  },
  data() {
    return {
      mouseOver: false
    }
  },
};
</script>

<style lang="scss" scoped>
.rx-widget-edit {
  position: relative;
  border: dotted;
  border-color: rgb(172, 172, 172);
  opacity: 0.65;
  pointer-events: none;
}
// .v-card:hover {
.rx-widget-edit:hover {
  opacity: 1;
}

.rx-widget-view {
   position: relative;
}

.wrap-edit-box {
  position: absolute; top:0px; left:0px;
   width:100%;
   height: 100%;
   pointer-events: fill;
}
</style>